import React, { useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { IRootState } from "../../reducers";
import {
  getEntity as getCandidateResourceInstance,
  sendForm,
  reset,
} from "../../reducers/resource.reducer";
import { SpinnerKonecta } from "../../shared/layout/spinner/Spinner";
import { Button, Col, Form, Row } from "reactstrap";
import { FormikProvider } from "formik";
import { initialValuesResource } from "./resourceModel";
import { ICandidateToResourceInstance } from "../../shared/model/candidate-to-resource-instance.model";
import { useFormikResource } from "./useFormikResource";
import { IField } from "../../shared/model/field.model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { ModalResponse } from "../../shared/dialog/modal-response";
import { IMessage } from "../../shared/model/message.model";
import { ModalError } from "../../shared/dialog/modal-error";
import { HeaderResourceCompleted } from "./header-resource-completed";
import { HeaderResourceIncomplete } from "./header-resource-incomplete";
import { FormBuilder } from "./formBuilder";
import { ApplicationType } from "../../shared/model/enumerations/application-type.model";

interface IResourceProps
  extends StateProps,
    DispatchProps,
    RouteComponentProps<{ token: string }> {}

const messageSuccess: IMessage = {
  title: "¡Formulario enviado con éxito!",
  body: "Muchas gracias por tu interés.",
};

export const Resource = (props: IResourceProps) => {
  const isMounted = useRef(true);
  const myRef = useRef<HTMLInputElement>(null);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [initialValues, setInitialValues] =
    useState<ICandidateToResourceInstance>(initialValuesResource);
  const executeScroll = () => {
    myRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const [errors, setErrors] = useState<number[]>([]);
  const { candidateResourceInstance: candidateToResourceInstance, loading } =
    props;

  const saveEntityConfirm = (formData: ICandidateToResourceInstance) => {
    props.sendForm(formData);
  };

  const { formik } = useFormikResource({
    initialValues,
    saveEntityConfirm,
    candidateToResourceInstance,
    setErrors,
    setShowModalConfirm,
  });

  const handleClose = () => {
    setShowModalConfirm(false);
  };

  const handleError = () => {
    window.location.reload();
  };

  const saveConfirm = () => {
    formik.handleSubmit();
  };

  const saveEntity = (e: any) => {
    e.preventDefault();
    setShowModalConfirm(true);
  };

  useEffect(() => {
    if (isMounted.current) {
      props.reset();
      props.getCandidateResourceInstance(props.match.params.token);
      executeScroll();
    }
  }, []);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      setInitialValues({
        ...initialValues,
        resourceToInstance: props.candidateResourceInstance.resourceToInstance,
      });
    }
  }, [props.candidateResourceInstance]);

  return (
    <div>
      {loading ? (
        <div className="mt-5">
          <SpinnerKonecta />
        </div>
      ) : (
        <>
          {candidateToResourceInstance?.isCompletedResource && (
            <HeaderResourceCompleted />
          )}
          {candidateToResourceInstance?.candidate && (
            <div className="container-resource">
              <HeaderResourceIncomplete
                candidateToResourceInstance={candidateToResourceInstance}
              />
              <Row className="justify-content-center container-form-resource">
                <section>
                  <div ref={myRef}></div>
                  <FormikProvider value={formik}>
                    <Form
                      autoComplete="off"
                      onSubmit={formik.handleSubmit}
                      className="form-resource"
                    >
                      {candidateToResourceInstance.resourceToInstance?.resource
                        ?.fields?.length ? (
                        candidateToResourceInstance.resourceToInstance.resource.fields.map(
                          (currentValue: IField, index: number) => (
                            <Row className="container-inputs-form" key={index}>
                              <Col>
                                <FormBuilder
                                  formik={formik}
                                  field={currentValue}
                                  index={index}
                                  errors={errors}
                                />
                              </Col>
                            </Row>
                          )
                        )
                      ) : (
                        <Row className="alert-main-page justify-content-center">
                          <div className="alert alert-warning">
                            No hay preguntas para responder, comuníquese con el
                            selector que le asignó el recurso
                          </div>
                        </Row>
                      )}
                      {candidateToResourceInstance.resourceToInstance?.resource
                        ?.fields?.length !== 0 ? (
                        <Row className="my-5">
                          <Col className="d-flex justify-content-end align-items-end">
                            <Button
                              className="btn-send-resource"
                              name="sendForm"
                              type="button"
                              onClick={(e) => saveEntity(e)}
                              // disabled={
                              //   !formik.isValid || (!formik.dirty && !formik.values?.id)
                              // }
                            >
                              Enviar
                              <FontAwesomeIcon icon={faArrowRight} />
                            </Button>
                          </Col>
                        </Row>
                      ) : undefined}
                    </Form>
                  </FormikProvider>
                </section>
              </Row>
            </div>
          )}

          {showModalConfirm && (
            <ModalResponse
              loading={props.loading}
              errorMessage={props.errorMessage}
              updateSuccess={props.updateSuccess}
              messageSuccess={messageSuccess}
              handleClose={handleClose}
              setShowModalConfirm={setShowModalConfirm}
              saveConfirm={saveConfirm}
            />
          )}
          {props.errorMessage && (
            <ModalError error={props.errorMessage} handleClose={handleError} />
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  candidateResourceInstance: storeState.resourceReducer.entity,
  loading: storeState.resourceReducer.loading,
  errorMessage: storeState.resourceReducer.errorMessage,
  updateSuccess: storeState.resourceReducer.updateSuccess,
});
const mapDispatchProps = {
  getCandidateResourceInstance,
  reset,
  sendForm,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchProps;

export default connect(mapStateToProps, mapDispatchProps)(Resource);
